(function () {
  var cartDrawer = document.querySelector('cart-drawer');
  var rafIds = {};

  function animateProperty(drawerInner, property, target) {
    cancelAnimationFrame(rafIds[property]);
    var start = parseFloat(drawerInner.style.getPropertyValue(property)) || 0;
    var startTime = null;

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var t = Math.min((timestamp - startTime) / 400, 1);
      drawerInner.style.setProperty(property, start + (target - start) * t);
      if (t < 1) rafIds[property] = requestAnimationFrame(step);
    }
    rafIds[property] = requestAnimationFrame(step);
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
    var progressEl = cartDrawer.querySelector('.cart-progress');
    var drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (!progressEl || !drawerInner) return;

    var qtyTarget = parseFloat(progressEl.dataset.progressQty);
    var priceTarget = parseFloat(progressEl.dataset.progressPrice);
    animateProperty(drawerInner, '--progress-qty', qtyTarget);
    animateProperty(drawerInner, '--progress-price', priceTarget);

    updateSegment(cartDrawer.querySelector('.cart-progress__segment--qty'), qtyTarget, qtyTarget >= 1);
    updateSegment(cartDrawer.querySelector('.cart-progress__segment--price'), priceTarget, priceTarget >= 1);
  });

  function updateSegment(segment, target, isComplete) {
    if (!segment) return;
    segment.classList.toggle('is-complete', isComplete);

    var track = segment.querySelector('.cart-progress__track');
    if (track) track.setAttribute('aria-valuenow', Math.round(target * 100));

    var label = segment.querySelector('.cart-progress__label');
    if (label) label.textContent = isComplete ? label.dataset.labelComplete : label.dataset.label;
  }
})();
